module.exports = __webpack_public_path__ + "static/media/whatsapp.ec69d1fa.png";